export default [
  {
    path: '/',
    component: () => import('@/views/home/index.vue'),
    children: [
      {
        path: '/',
        name: 'home',
        component: () => import('@/views/home/Home.vue'),
        meta: {
          layout: 'Home',
          noAuth: true
        }
      },
      {
        path: 'news',
        name: 'homeNews',
        component: () => import('@/views/home/News.vue'),
        meta: {
          layout: 'Home',
          noAuth: true
        }
      },
      {
        path: 'newsDetail',
        name: 'newsDetail',
        component: () => import('@/views/home/NewsDetail.vue'),
        meta: {
          layout: 'Home',
          noAuth: true
        }
      }
    ]
  }
]
